export const RADAR = 0
export const CHART = 1
export const TABLE = 2

export const MODES = [
    RADAR,
    CHART,
    TABLE
]
